import styled from 'styled-components';
import Text from '../../../../../../components/Text';
import StatisticItem from '../../../components/StatisticItem';
import IcSuccess from '../../../../../../components/Icon/icons/IcSuccess';
import IcPending from '../../../../../../components/Icon/icons/IcPending';
import IcDollar from '../../../../../../components/Icon/icons/IcDollar';
import IcFail from '../../../../../../components/Icon/icons/IcFail';
import { IGetSummaryRequestSMSResponse } from '../../../../interfaces/apis';
import { formatCurrency } from '../../../../../../utils/formatCurrency';

interface IRequestSmsSummaryProps {
  data: IGetSummaryRequestSMSResponse | null;
}

const RequestSmsSummary = ({ data }: IRequestSmsSummaryProps) => {
  return (
    <Container>
      <Text variant='H5' style={{ fontWeight: 600 }}>
        Request SMS Purchase
      </Text>
      <Content>
        <StatisticItem label='Approved' value={data?.totalApproved || 0} icon={<IcSuccess fill='#0DA472' />} />
        <StatisticItem label='Pending' value={data?.totalPending || 0} icon={<IcPending fill='#008BFF' />} />
        <StatisticItem label='Rejected' value={data?.totalCancelled || 0} icon={<IcFail fill='#F53F3F' />} />
        <StatisticItem
          label='Total Cost'
          value={formatCurrency(data?.totalCost || 0)}
          icon={<IcDollar fill='#9747FF' width={48} height={48} />}
        />
      </Content>
    </Container>
  );
};

export default RequestSmsSummary;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
`;
